import { useEffect } from 'react';
import { useLogin, usePrivy } from '@privy-io/react-auth';

export default function AuthButton() {
  const { ready, authenticated } = usePrivy();
  // Disable login when Privy is not ready or the user is already authenticated
  const disableLogin = !ready || (ready && authenticated);

  const { login } = useLogin();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    !disableLogin && login();
  }, [disableLogin]);

  return <></>;
}
